import { makeCancellableAPIRequest } from "restAPI";

const FeedsAPI = {
    getFeeds(params={}, showDefaultMessage = true){
        return makeCancellableAPIRequest(
            "GET",
            `/api/feed/?${params}`,
            {},
            showDefaultMessage
        )
    },
    getFeedsV2(data={}, showDefaultMessage = true){
        return makeCancellableAPIRequest(
            "POST",
            `/api/v2/feed`,
            {data},
            showDefaultMessage
        )
    },
    getFeedDetails(source, CVEId) {
        return makeCancellableAPIRequest(
            "GET",
            `/api/feed/${source}/${CVEId}`
        )
    }
}
		


export default FeedsAPI;